"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutChecker = void 0;
var util_1 = require("../../../util");
var websocket_channel_1 = require("../../../websocket-channel");
/**
 * 定时检测所有队列数据是否发送超时
 */
var TimeoutChecker = /** @class */ (function () {
    function TimeoutChecker(messageSendQueue, dependency) {
        this.messageSendQueue = messageSendQueue;
        this.dependency = dependency;
        this.sendTimeoutTimer = 0;
    }
    TimeoutChecker.prototype.dispose = function () {
        this.clearTimer();
    };
    TimeoutChecker.prototype.clearTimer = function () {
        clearTimeout(this.sendTimeoutTimer);
        this.sendTimeoutTimer = 0;
    };
    /**
     * 定时检查，兜底避免消息发送超时，同时没有结束
     */
    TimeoutChecker.prototype.startCheckSendTimeout = function () {
        var _this = this;
        if (this.sendTimeoutTimer) {
            clearTimeout(this.sendTimeoutTimer);
            this.sendTimeoutTimer = 0;
        }
        this.sendTimeoutTimer = setTimeout(function () {
            _this.checkSendTimeout();
        }, 1000);
    };
    TimeoutChecker.prototype.checkSendTimeout = function () {
        var timeoutMessages = this.messageSendQueue.filter(this.timeoutMessage);
        timeoutMessages.forEach(function (message) {
            message.state = websocket_channel_1.MessageState.WAITING;
            if (message.retryCount >= message.maxRetryCount) {
                util_1.ConnectionLog.warn("timeout-checker: send message timeout, taskId = " + message.taskId + ", cmd = " + message.cmd + ".");
                message.retryCount = 0;
            }
        });
        if (timeoutMessages.length > 0) {
            this.dependency.trySendMessage();
        }
        var currentMessages = this.messageSendQueue.filter(function (item) { return !!item; });
        if (currentMessages.length !== 0) {
            this.startCheckSendTimeout();
        }
    };
    TimeoutChecker.prototype.timeoutMessage = function (message) {
        var currentTime = websocket_channel_1.RoomUtil.getCurrentTime();
        return (message.state === websocket_channel_1.MessageState.SENDING
            || message.state === websocket_channel_1.MessageState.WAIT_ACCEPT)
            && currentTime - message.lastSendTime > message.timeout;
    };
    return TimeoutChecker;
}());
exports.TimeoutChecker = TimeoutChecker;
